// Add your JavaScript code here
import "./styles.css";

import battleshipsImage from "./Assets/Battleships.png";
import ticTacToeImage from "./Assets/tictactoe.png";
import weatherAppImage from "./Assets/weather.png";
import restautantPageImage from "./Assets/restaurant.png";
import etchNSketchImage from "./Assets/etchNSketch.png";
import adminDashboardImage from "./Assets/adminDashboard.png";
import calculatorImage from "./Assets/calc.png";

let githubSVG = `<svg viewBox="0 0 128 128" height="40px" width="40px">
<g fill="#181616"><path fill-rule="evenodd" clip-rule="evenodd" d="M64 5.103c-33.347 0-60.388 27.035-60.388 60.388 0 26.682 17.303 49.317 41.297 57.303 3.017.56 4.125-1.31 4.125-2.905 0-1.44-.056-6.197-.082-11.243-16.8 3.653-20.345-7.125-20.345-7.125-2.747-6.98-6.705-8.836-6.705-8.836-5.48-3.748.413-3.67.413-3.67 6.063.425 9.257 6.223 9.257 6.223 5.386 9.23 14.127 6.562 17.573 5.02.542-3.903 2.107-6.568 3.834-8.076-13.413-1.525-27.514-6.704-27.514-29.843 0-6.593 2.36-11.98 6.223-16.21-.628-1.52-2.695-7.662.584-15.98 0 0 5.07-1.623 16.61 6.19C53.7 35 58.867 34.327 64 34.304c5.13.023 10.3.694 15.127 2.033 11.526-7.813 16.59-6.19 16.59-6.19 3.287 8.317 1.22 14.46.593 15.98 3.872 4.23 6.215 9.617 6.215 16.21 0 23.194-14.127 28.3-27.574 29.796 2.167 1.874 4.097 5.55 4.097 11.183 0 8.08-.07 14.583-.07 16.572 0 1.607 1.088 3.49 4.148 2.897 23.98-7.994 41.263-30.622 41.263-57.294C124.388 32.14 97.35 5.104 64 5.104z"></path><path d="M26.484 91.806c-.133.3-.605.39-1.035.185-.44-.196-.685-.605-.543-.906.13-.31.603-.395 1.04-.188.44.197.69.61.537.91zm2.446 2.729c-.287.267-.85.143-1.232-.28-.396-.42-.47-.983-.177-1.254.298-.266.844-.14 1.24.28.394.426.472.984.17 1.255zM31.312 98.012c-.37.258-.976.017-1.35-.52-.37-.538-.37-1.183.01-1.44.373-.258.97-.025 1.35.507.368.545.368 1.19-.01 1.452zm3.261 3.361c-.33.365-1.036.267-1.552-.23-.527-.487-.674-1.18-.343-1.544.336-.366 1.045-.264 1.564.23.527.486.686 1.18.333 1.543zm4.5 1.951c-.147.473-.825.688-1.51.486-.683-.207-1.13-.76-.99-1.238.14-.477.823-.7 1.512-.485.683.206 1.13.756.988 1.237zm4.943.361c.017.498-.563.91-1.28.92-.723.017-1.308-.387-1.315-.877 0-.503.568-.91 1.29-.924.717-.013 1.306.387 1.306.88zm4.598-.782c.086.485-.413.984-1.126 1.117-.7.13-1.35-.172-1.44-.653-.086-.498.422-.997 1.122-1.126.714-.123 1.354.17 1.444.663zm0 0"></path></g>
</svg>`;

let linksSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="50px" width="50px"><title>link</title><path d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z" /></svg>`;

let projects = [
  {
    title: "Battleships",
    description: "A battleships game built with JavaScript, HTML and CSS.",
    image: battleshipsImage,
    alt: "battleships-project",
    links: [
      {
        url: "https://github.com/devoid-of-thought/odin-battleship",
        svg: githubSVG,
      },
      {
        url: "https://devoid-of-thought.github.io/odin-battleship/",
        svg: linksSVG,
      },
    ],
  },
  {
    title: "Tic Tac Toe",
    description: "A tic tac toe game built with JavaScript, HTML and CSS.",
    image: ticTacToeImage,
    alt: "tic-tac-toe-project",
    links: [
      {
        url: "https://github.com/devoid-of-thought/odin-tic-tac-toe",
        svg: githubSVG,
      },
      {
        url: "https://devoid-of-thought.github.io/odin-tic-tac-toe/",
        svg: linksSVG,
      },
    ],
  },
  {
    title: "Weather App",
    description: "A weather app built with JavaScript, HTML and CSS.",
    image: weatherAppImage,
    alt: "weather-app-project",
    links: [
      {
        url: "https://github.com/devoid-of-thought/odin-weather-forecast",
        svg: githubSVG,
      },
      {
        url: "https://devoid-of-thought.github.io/odin-weather-forecast/",
        svg: linksSVG,
      },
    ],
  },
    {
    title: "Etch N Sketch",
    description: "An etch n sketch app built with JavaScript, HTML and CSS.",
    image: etchNSketchImage,
    alt: "etch-n-sketch-project",
    links: [
      {
        url: "https://github.com/devoid-of-thought/odin-etch-n-sketch",
        svg: githubSVG,
      },
      {
        url: "https://devoid-of-thought.github.io/odin-etch-n-sketch/",
        svg: linksSVG,
      },
    ],
  },
  {
    title: "Restaurant Page",
    description: "A restaurant page built with JavaScript, HTML and CSS.",
    image: restautantPageImage,
    alt: "restaurant-page-project",
    links: [
      {
        url: "https://github.com/devoid-of-thought/odin-restaurant-page/tree/main",
        svg: githubSVG,
      },
      {
        url: "https://devoid-of-thought.github.io/odin-restaurant-page/#",
        svg: linksSVG,
      },
    ],
  },
  {
    title: "Calculator",
    description: "A calculator app built with JavaScript, HTML and CSS.",
    image: calculatorImage,
    alt: "calculator-project",
    links: [
      {
        url: "https://github.com/devoid-of-thought/odin-calculator",
        svg: githubSVG,
      },
      {
        url: "https://devoid-of-thought.github.io/odin-calculator/",
        svg: linksSVG,
      },
    ],
  },
  {
    title: "Admin Dashboard",
    description: "An admin dashboard built with JavaScript, HTML and CSS.",
    image: adminDashboardImage,
    alt: "admin-dashboard-project",
    links: [
      {
        url: "https://github.com/devoid-of-thought/odin-admin-dashboard",
        svg: githubSVG,
      },
      {
        url: "https://devoid-of-thought.github.io/odin-admin-dashboard/",
        svg: linksSVG,
      },
    ],
  },
];

function createProjectCard(project) {
  const card = document.createElement("div");
  card.classList.add("project-card");
  const img = document.createElement("img");
  img.src = project.image;
  img.alt = project.alt;
  card.appendChild(img);
  const content = document.createElement("div");
  content.classList.add("project-card-content");
  const head  = document.createElement("div");
  head.classList.add("project-card-head");
  const title = document.createElement("h1");
  title.textContent = project.title;
  head.appendChild(title);
  content.appendChild(head);
  const description = document.createElement("p");
  description.textContent = project.description;
  content.appendChild(description);
  const linksSection = document.createElement("section");
  linksSection.classList.add("project-link");
  linksSection.setAttribute("aria-label", `project-${project.title}-links`);
  project.links.forEach((link) => {
    const a = document.createElement("a");
    a.href = link.url;
    a.innerHTML = link.svg;
    linksSection.appendChild(a);
  });
  head.appendChild(linksSection);
  card.appendChild(content);
  return card;
}

for (let project of projects) {
  const projectCard = createProjectCard(project);
  document.getElementById("projects").appendChild(projectCard);
}
